/** Maps filter key to aql search field */
export const mapVehicleFiltersToAQLFields = {
    hasWords: ['haswords'],
    make: ['make'],
    model: ['model'],
    color: ['color'],
    checkIn: ['checkindate', 'cd'],
    year: ['year'],
    odo: ['odo'],
    photos: ['photos'],
    hasCr: ['cr'],
    hasTitle: ['title'],
} as const

/** Maps filter key to aql search field */
export const mapSaleFiltersToAQLFields = {
    saleStatus: ['status'],
    saleDate: ['saledate', 'sd'],
    lane: ['lane'],
    run: ['run'],
    ranCount: ['rancount'],
    lot: ['lot'],
    floor: ['floor'],
    mmr: ['mmr'],
    blackbook: ['blackbook'],
} as const

/** Maps filter key to aql search field */
export const mapCompanyFiltersToAQLFields = {
    seller: ['seller'],
    sellerId: ['consignorid', 'consignoridnot', 'notconsignorid', 'notsellerid', 'sellerid', 'selleridnot'],
    sellerType: ['sellertype', 'sellertypenot', 'notsellertype'],
    buyer: ['buyer'],
    buyerId: ['buyerid', 'buyeridnot', 'notbuyerid'],
    buyerType: ['buyertype', 'buyertypenot', 'notbuyertype'],
    rep: [
        'rep',
        'notrep',
        'repnot',
        'repseller',
        'notrepseller',
        'repsellernot',
        'repbuyer',
        'notrepbuyer',
        'repbuyernot',
        'salesrep',
        'notsalesrep',
        'salesrepnot',
    ],
    isFavorite: ['favorite', 'fav'],
} as const

/** Maps filter key to aql search field */
export const mapContactFiltersToAQLFields = {
    hasWords: ['haswords'],
    contactStatus: ['clstatus'],
    contactMethod: ['clmethod'],
    creatorFullName: ['createdby'],
    followupFullName: ['followupby'],
    completedFullName: ['completedby'],
    contactedAt: ['contacted'],
    followupAt: ['followedup'],
    completedAt: ['completed'],
} as const

/** Maps filter key to aql search field */
export const mapAllFiltersToAQLFields = {
    ...mapVehicleFiltersToAQLFields,
    ...mapSaleFiltersToAQLFields,
    ...mapCompanyFiltersToAQLFields,
    ...mapContactFiltersToAQLFields,
} as const

/** Maps filter key to aql search field */
export const mapFiltersToAQLFields = mapAllFiltersToAQLFields

export type AQLFilterKey = keyof typeof mapFiltersToAQLFields

export type NotOperatorFilterKey = Extract<AQLFilterKey, 'rep' | 'buyerId' | 'buyerType' | 'sellerId' | 'sellerType'>

export type HasWordsFilterKey = 'hasWords' | ''
export type YearFilterKey = 'year'
export type OdometerFilterKey = 'odo'

export type LowHighOperatorFilterKey =
    | Extract<AQLFilterKey, 'photos' | 'ranCount' | 'lot' | 'floor' | 'mmr' | 'blackbook'>
    | YearFilterKey
    | OdometerFilterKey

export type SimpleFilterKey = Exclude<
    AQLFilterKey,
    LowHighOperatorFilterKey | NotOperatorFilterKey | YearFilterKey | OdometerFilterKey | HasWordsFilterKey
>

export type AlphaNumericFilterKey = Extract<
    AQLFilterKey,
    | 'make'
    | 'model'
    | 'color'
    | 'lane'
    | 'run'
    | 'seller'
    | 'buyer'
    | 'creatorFullName'
    | 'followupFullName'
    | 'completedFullName'
>

export type NumberOperatorFilterKey = Extract<
    AQLFilterKey,
    'checkIn' | 'saleDate' | 'contactedAt' | 'followupAt' | 'completedAt'
>

export type SelectValueFilterKey = Extract<
    AQLFilterKey,
    'hasCr' | 'hasTitle' | 'saleStatus' | 'isFavorite' | 'contactStatus' | 'contactMethod'
>

// never
export type RestFilterKeys = Exclude<
    AQLFilterKey,
    | LowHighOperatorFilterKey
    | NotOperatorFilterKey
    | YearFilterKey
    | OdometerFilterKey
    | HasWordsFilterKey
    | AlphaNumericFilterKey
    | NumberOperatorFilterKey
    | SelectValueFilterKey
>
